import { Injectable } from '@angular/core';
import { AssetLoader } from '../loaders/asset.loader';
import { AppConfig } from '../models/app-config';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  static config: AppConfig;
  private readonly url = `assets/config/config.json`;

  constructor(private readonly assetLoader: AssetLoader) {
  }

  async init(): Promise<any> {
    const value = await this.assetLoader.load(this.url).toPromise();

    AppConfigService.config = value;
  }

  getConfig(): AppConfig {
    return AppConfigService.config;
  }
}
